module.exports = __webpack_public_path__ + "img/amex-card-logo.6c1275bd.svg";